export const triggerMobile = function (payload) {
  if (window.hasOwnProperty('webkit') && window.webkit.messageHandlers && window.webkit.messageHandlers.hasOwnProperty('trigger')) {
    window.webkit.messageHandlers.trigger.postMessage(JSON.stringify(payload));
  }
  if (typeof Android != 'undefined' && Android.hasOwnProperty('trigger')) {
    Android.trigger(JSON.stringify(payload));
  } else {
    console.log('payload', payload);
  }
};

export const registerFunction = (cmd, func, resolvePromise, rejectPromise) => {
  if (!window.registeredFunctions) {
    window.registeredFunctions = {};
  }

  if (!window.registeredFunctions[cmd]) {
    window.registeredFunctions[cmd] = { func: func, resolve: resolvePromise, reject: rejectPromise };
  }

  if (!window.callFunction) {
    window.callFunction = (cmd, ...parameters) => {
      if (!window.registeredFunctions[cmd]) {
        // funzione non esiste!
        return;
      }

      let object = window.registeredFunctions[cmd];
      object.func(...parameters, object.resolve, object.reject);

      //unregisterFunction(cmd);
    };
  }
};

export const unregisterFunction = (cmd) => {
  if (window.registeredFunctions && window.registeredFunctions[cmd] && window.registeredFunctions[cmd].resolve && window.registeredFunctions[cmd].reject) {
    delete window.registeredFunctions[cmd];
  }
};